module.exports = __webpack_public_path__ + "r-v3/img/ico_pin_white.48275db4.svg";